import LoadingAnimation from '../../../../assets/animations/loading.gif';
import { ILoadingFullScreen } from '../../../interfaces/globals';
import './LoadingFullScreen.scss';

const LoadingFullScreen = ({ show, text }: ILoadingFullScreen) => {
  return (
    <div
      className={`loading-full-screen flex flex-col justify-center items-center origin-center pointer-events-none ${show ? 'loading-full-screen--show opacity-100' : 'opacity-0'}`}
    >
      <div className="loading-full-screen__img flex justify-center items-center">
        <img src={LoadingAnimation} alt="Loading" className="w-full h-full object-cover" />
      </div>
      {text && <div className="loading-full-screen__text text-center m-0">{text}</div>}
    </div>
  );
};

export default LoadingFullScreen;
